// utils/formatNumber.js
export const formatNumber = (num, withDollar = false) => {
  if (num === null || num === undefined) return "...";

  let formatted;

  if (num >= 1_000_000_000) {
    formatted = (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  } else if (num >= 1_000_000) {
    formatted = (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1_000) {
    formatted = (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  } else {
    formatted = num.toString();
  }

  return withDollar ? `$${formatted}` : formatted;
};